import { render } from "./BtnVisualizar.vue?vue&type=template&id=16c630c5"
import script from "./BtnVisualizar.vue?vue&type=script&lang=js"
export * from "./BtnVisualizar.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__